module.exports = __webpack_public_path__ + "static/img/s402.64df13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s402.png
// module id = 554
// module chunks = 3